(function() {
  angular
  .module('meanApp')
  .factory('productsManager', productsManager);

  productsManager.$inject = ["Product", "modelManager", 'httpAuth', '$q'];
  function productsManager (Product, modelManager, httpAuth, $q) {
		return angular.extend({
			search: function(searchString, resultPerPage) {
				var deferred = $q.defer(),
	            scope = this;
	            
                httpAuth.get('/api/products/search'+'?searchString='+encodeURI(searchString)+'&resultPerPage='+resultPerPage)
                .success(function(result) {
                    /**var users = []; 
                    usersArray.docs.forEach(function(userData) {
                        console.log(userData);
                        var user = scope._retrieveInstance(userData._id, userData);
                        users.push(user);
                    });**/
                    deferred.resolve(result);
                })
                .error(function(err) {
                    deferred.reject(err);
                });

	            return deferred.promise;
			}
		}, modelManager.init(Product));
  };

})();